import React from "react";
import "../css-coding/ChallengesResolved.css";

// Icons
const LightbulbIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 14c.2-.8.8-1.5 1.7-2 1.4-.8 2.3-2.3 2.3-4.1a3 3 0 0 0-6 0c0 1.8.9 3.3 2.3 4.1.9.5 1.5 1.2 1.7 2" />
    <path d="M22 6H2" />
    <path d="M6 14h12" />
  </svg>
);

const BriefcaseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);


const UserCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M16 11l2 2 4-4" />
  </svg>
);


// Content blocks
const features = [
  {
    icon: LightbulbIcon,
    title: "Unwavering Commitment to Quality",
    description:
      "Instead of competing on price, we focused on delivering exceptional quality that justified our rates.",
  },
  {
    icon: BriefcaseIcon,
    title: "Building Strong Relationships",
    
    description:
      "Our transparent communication, timely delivery, and extra effort turned clients into long-term partners.",
  },
  {
    icon: UserCheckIcon,
    title: "Continuous Learning and Adaptation",
    description:
      "We stayed updated with the latest industry trends and techniques, keeping us ahead of the competition.",
  },
  {
    icon: LightbulbIcon,
    title: "Strategic Partnerships",
    description:
      "We collaborated with complementary service providers to offer full-suite solutions.",
  },
  {
    icon: BriefcaseIcon,
    title: "Personal Branding",
    description:
      "We leveraged our founders’ personal brands to build trust and attract high-intent clients.",
  },
];

const FeatureBlock = ({ icon: Icon, title, description }) => (
  <div className="feature-block-cr">
    <div className="feature-icon-wrapper-cr">
      <Icon />
    </div>
    <h3 className="feature-title-cr">{title}</h3>
    <p className="feature-description-cr">{description}</p>
  </div>
);

const ChallengesResolved = () => {
  return (
    <div className="page-container-cr">
      <div className="title-section-cr">
        <h2 className="main-title-cr">How We Faced These Struggles</h2>
      </div>

      <div className="main-content-section-cr">
        <div className="features-grid-cr">
          {features.map((feature, index) => (
            <FeatureBlock key={index} {...feature} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChallengesResolved;

